import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/DeleteOutline";

// os 8 tipos do backend (DatasetService/fields). value = id no backend, label = UI.
export const FIELD_TYPES = [
  { value: "texto", label: "Texto" },
  { value: "numero", label: "Número" },
  { value: "booleano", label: "Verdadeiro/Falso" },
  { value: "data", label: "Data" },
  { value: "opcao", label: "Opção (lista)" },
  { value: "telefone", label: "Telefone" },
  { value: "email", label: "E-mail" },
  { value: "json", label: "JSON" },
];

const useStyles = makeStyles(theme => ({
  head: { fontSize: 12.5, fontWeight: 600, color: "#5B6470", margin: theme.spacing(1, 0) },
  row: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8 },
  name: { flex: "0 0 150px" },
  label: { flex: 1 },
  type: { flex: "0 0 150px" },
  options: { flex: 1 },
  hint: { fontSize: 11.5, color: "#929AA4", marginTop: 2 },
}));

// Editor das colunas de uma tabela. `fields` = [{ name, label, type, options, indexed }].
// options é STRING separada por vírgula na UI (convertida em array por quem salva).
const DatasetFieldsEditor = ({ fields, onChange, types = FIELD_TYPES }) => {
  const classes = useStyles();

  const update = (i, patch) => {
    const next = fields.slice();
    next[i] = { ...next[i], ...patch };
    onChange(next);
  };
  const add = () => onChange([...(fields || []), { name: "", label: "", type: "texto", options: "" }]);
  const remove = i => onChange(fields.filter((_, j) => j !== i));

  return (
    <div>
      <div className={classes.head}>Campos (colunas)</div>
      {(fields || []).map((f, i) => (
        <div key={i}>
          <div className={classes.row}>
            <TextField
              className={classes.name}
              label="nome"
              placeholder="ex.: template"
              value={f.name}
              onChange={e => update(i, { name: e.target.value.replace(/[^a-z0-9_]/gi, "").toLowerCase() })}
              variant="outlined"
              size="small"
            />
            <TextField
              className={classes.label}
              label="rótulo (opcional)"
              value={f.label || ""}
              onChange={e => update(i, { label: e.target.value })}
              variant="outlined"
              size="small"
            />
            <TextField
              className={classes.type}
              label="tipo"
              select
              value={f.type}
              onChange={e => update(i, { type: e.target.value })}
              variant="outlined"
              size="small"
            >
              {types.map(t => (
                <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
              ))}
            </TextField>
            <Tooltip title="Usado em filtro (indexar depois)">
              <Checkbox size="small" color="default" checked={!!f.indexed} onChange={e => update(i, { indexed: e.target.checked })} />
            </Tooltip>
            <IconButton size="small" onClick={() => remove(i)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
          {f.type === "opcao" && (
            <div className={classes.row}>
              <TextField
                className={classes.options}
                label="opções (separadas por vírgula)"
                placeholder="ex.: enviado, falhou"
                value={f.options || ""}
                onChange={e => update(i, { options: e.target.value })}
                variant="outlined"
                size="small"
              />
            </div>
          )}
        </div>
      ))}
      <Button size="small" startIcon={<AddIcon />} onClick={add} style={{ textTransform: "none" }}>
        Adicionar campo
      </Button>
    </div>
  );
};

export default DatasetFieldsEditor;
